import React from "react";
import Constant from "../../Constant";
import First from "../../Assets/images/ts1.svg";
import Sec from "../../Assets/images/ts2.svg";
import Third from "../../Assets/images/ts3.svg";
import Fourth from "../../Assets/images/ts4.svg";
import Five from "../../Assets/images/ts5.svg";
import BgB from "../../Assets/images/spB.png";
import BgS from "../../Assets/images/spS.png";
import SaveCom from "./SaveCom";
import { motion } from "framer-motion";

function Save() {
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.2 },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 30 },
    show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
  };

  const steps = [
    {
      img: First,
      header: "Create or Join a Pod",
      con: "Pick a goal (Education, Umrah, Business).",
    },
    {
      img: Third,
      header: "Invite Trusted Members",
      con: "Build your own group or tap into public pods.",
    },
    {
      img: Sec,
      header: "Save Monthly",
      con: "Each member contributes automatically.",
    },
    {
      img: Fourth,
      header: "Invest Together",
      con: "Pooled funds go into halal options.",
    },
    {
      img: Five,
      header: "Monitor & Grow",
      con: "See progress and get helpful nudges.",
    },
  ];

  return (
    <div className="px-6 sm:px-24 py-12 sm:py-20 bg-text-gray ">
      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.2 }}
        variants={container}
      >
        <motion.h1
          variants={item}
          className="font-[400] text-[24px] sm:text-[40px] mb-10 text-text-color1"
        >
          Group <span className={Constant.linearColor}>Savings</span>
        </motion.h1>
        <p className="text-[14px] mb-10 font-[500] text-text-color1 sm:text-[20px]">
          Unite with family, friends, or community members to collectively save and invest for shared goals with Group Savings.
          This collaborative feature allows you to pool resources towards common objectives, fostering a sense of community and mutual support, all within a fully Shariah-compliant framework.
          Experience the power of collective ethical wealth building.        </p>

        <div className="hidden sm:grid sm:grid-cols-3 gap-8 items-center">
          <motion.div
            variants={container}
            className="flex flex-col justify-between gap-8"
          >
            {steps.slice(0, 2).map((step, i) => (
              <motion.div key={i} variants={item} className="flex gap-3">
                <span className="text-lg font-bold text-purple-600">
                  {i + 1}.
                </span>
                <SaveCom img={step.img} header={step.header} con={step.con} />
              </motion.div>
            ))}
          </motion.div>

          <motion.div
            variants={item}
            className="flex justify-center items-center"
          >
            <img
              src={BgB}
              alt="phone background"
              className="w-[60%] mx-auto"
            />
          </motion.div>

          <motion.div
            variants={container}
            className="flex flex-col justify-between gap-8"
          >
            {steps.slice(2, 4).map((step, i) => (
              <motion.div key={i} variants={item} className="flex gap-3">
                <span className="text-lg font-bold text-purple-600">
                  {i + 3}.
                </span>
                <SaveCom img={step.img} header={step.header} con={step.con} />
              </motion.div>
            ))}
          </motion.div>
        </div>

        <motion.div
          variants={item}
          className="hidden sm:flex justify-center mt-12 sm:mt-16"
        >
          <div className="w-[70%] sm:w-[40%] flex gap-3">
            <span className="text-lg font-bold text-purple-600">5.</span>
            <SaveCom
              img={steps[4].img}
              header={steps[4].header}
              con={steps[4].con}
            />
          </div>
        </motion.div>

        <div className="block sm:hidden mt-10">
          <img
            src={BgS}
            alt="phone background"
            className="mb-10 w-[70%] mx-auto"
          />
          {steps.map((step, i) => (
            <motion.div
              key={i}
              variants={item}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              className="flex gap-3 mb-6"
            >
              <span className="text-lg font-bold text-purple-600">
                {i + 1}.
              </span>
              <SaveCom img={step.img} header={step.header} con={step.con} />
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>
  );
}

export default Save;
